import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { ActionBar, ReferalIcon } from '@dreryk/react-components';

import { visitActionBarTranslationKeys } from '../../translations';

import { useElectronicDocumentsDropdownItems } from './ReferralAction.hooks';
import { VisitActionBarOrder } from './VisitActionBar';

type ElectronicDocumentsActionProps = {
   readonly visitId: Visit['id'];
   readonly reopened: boolean;
};

export const ElectronicDocumentsAction = (props: ElectronicDocumentsActionProps): JSX.Element | null => {
   const items = useElectronicDocumentsDropdownItems(props.visitId, props.reopened);

   return (
      <ActionBar.OptionalDropdown
         testId='electronicDocuments'
         triggerIcon={<ReferalIcon />}
         triggerLabel={visitActionBarTranslationKeys.electronicDocuments}
         order={VisitActionBarOrder.ElectronicReferral}
         hideIfEmpty
      >
         {items}
      </ActionBar.OptionalDropdown>
   );
};
